import request from "@/util/request.js";
export const areaTree = token => {
  return request.post("api/sansint-energy/areaEnergyReport/areaTree", {
    token
  });
};
export const areaTreeCode = token => {
  return request.post("api/sansint-energy/areaEnergyReport/areaTreeCode", {
    token
  });
};
// 区域用能
export const areaEnergyById = (token, date, areaId, dateType) => {
  return request.post("api/sansint-energy/areaEnergyReport/areaEnergyById", {
    token,
    areaId,
    dateType,
    date
  });
};
// 设备用能分析
export const selectAllBranchApp = token => {
  return request.post(
    "api/sansint-energy/branchEnergyReport/selectAllBranchApp",
    {
      token
    }
  );
};
// 设备用能列表
export const branchEnergyById = (token, date, ids, dateType) => {
  return request.post(
    "api/sansint-energy/branchEnergyReport/branchEnergyById",
    {
      token,
      ids,
      dateType,
      date
    }
  );
};
